import React, { FC, useMemo } from "react";
import "./style.css";
import FileUpload from "../FileUploade";
import { IImgField } from "./ImgField.type";
import { useTranslation } from "react-i18next";

const ImgField: FC<IImgField> = ({ recordID, isMulti = false, setImg, label, Img, ImgLink, placeHolderName }) => {

  const { t } = useTranslation()

  const pictures = useMemo(() => {
    return Img?.map((fileImg: File) => URL?.createObjectURL(fileImg));
  }, [Img, ImgLink]);

  return (
    <div className="col-sm-12">
      <br />
      <FileUpload
        isMulti={isMulti}
        recordID={recordID}
        setValue={setImg}
        label={label}
        className={pictures?.length && "d-none "}
        type={"Img"}
        accept={"./png,.jpeg,.jpg"}
        placeHolderName={placeHolderName}
      />

      {pictures?.length ? (
        <>
          <div>{t(label)}</div>
          <br />
          <div className="row">
            {pictures.map((picture: string, index: number) =>
              <div key={index} className="col-md-4 col-md-6  Img-cotainer">
                <label htmlFor={`File_${recordID}_${label}_${"Img"}`}>
                  <img src={picture} alt="Profile" />
                </label>
              </div>
            )}
          </div>
        </>
      ) : ""}
    </div>
  );
};

export default ImgField;
